// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KIlS","textarea":"styles_textarea__3IOIr"};